export default "__VITE_ASSET__DBu_BzEp__"